import Model from "../Model";

class BubblesGestnoGest extends Model{

    buildUrl ({ param }) {
        return ['industrialgroupview/getbyid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BubblesGestnoGest;